const publicPath = process.env.BASE_URL
export const imagePreview = `${publicPath}templates/image-preview.jpeg`
export const defaultProfile = `${publicPath}templates/profile-empty.png`
